/** @module ProgressBarChartComponent */
import ProgressBarChartViz from '../vizs/ProgressBarChartViz'
import BaseComponent from './BaseComponent'

/**
 * {-EN-}
 * # {componentLabel} (`class {componentClassName}`)
 * A progress bar chart is a bar representation of an actual performance in comparision with a predetermined schedule.
 *
 * ### Example Usage
 * ```javascript
 *   import {ProgressBarChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new ProgressBarChart($el, data, config);
 *
 * ```
 *
 * This chart is intended to draw a progress chart with bar shape. For donut shape see [DonutProgressChart](#/developer/DonutProgressChartComponent)
 *
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 columns. Each row represents a layer: the first column should be the category id/label, the second column its value and the third column its total expected value.
 *
 * | category | value  | total  |
 * | -------- | ------ | ------ |
 * |   a      |    22.4|     100|
 * |   b      |    52.3|      60|
 *
 * {.data-table}
 *
 * {-ES-}
 * # {componentLabelEs} (`class {componentClassName}`)
 * Un gráfico de progreso de barras es una representación en forma de barra de un desempeño real en comparación con un cronograma predeterminado.
 *
 * ### Ejemplo de uso
 * ```javascript
 *   import {ProgressBarChart} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new ProgressBarChart($el, data, config);
 *
 * ```
 *
 * Esta gráfica está destinada a dibujar un gráfico de progreso con forma de barra. Para ver la representación en forma donut, consulta [Gráfico de progreso en donut](#/developer/DonutProgressChartComponent)
 *
 * ### Estructura de datos {.section-data-structure}
 * Los datos tabulares de este gráfico deben ser una tabla con 3 columnas. Cada fila representa una capa: la primera columna debe ser la identificación/etiqueta de la categoría, la segunda columna su valor y la tercera columna su valor total esperado.
 *
 * | categoria | valor  | total  |
 * | --------- | ------ | ------ |
 * |   a       |    22.4|     100|
 * |   b       |    52.3|      60|
 *
 * {.data-table}
 */
export default class ProgressBarChartComponent extends BaseComponent {
  static componentLabel = 'Progress Bar chart'
  static componentLabelEs = 'Gráfico de barras de progreso'
  static vizClass = ProgressBarChartViz
  static dataFormat = [
    { index: 0, axis: 'x0', types: [String], role: 'id', roleLabel: 'Category' },
    { index: 1, axis: 'y0', types: [Number], role: 'value', roleLabel: 'Value' },
    { index: 2, axis: '', types: [Number], role: 'total', roleLabel: 'Total' },
  ]
  constructor($root, config, data) {
    super($root, config, data)
  }
  static defaultConfig = {
    title: this.componentLabel,
    mode: 'progress',
    horizontal: {
      exposed: false,
      nonEditable: true,
      value: true,
    },
    AxisHelper: {
      x: {
        /**
         * {-EN-} Show/hide labels for each bar.
         * {-ES-} Mostrar/ocultar etiquetas para cada barra.
         */
        showTickValues: {
          default: true,
          exposed: true,
        },
      },
    },
    TooltipBehavior: {
      axis: {
        y: {
          tooltipValueFormat: {
            exposed: true,
            nonEditable: false,
          },
        },
      },
    },
  }
}
